import {API} from 'aws-amplify';
import axios from "axios";

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';
const baseURL = process.env.REACT_APP_APIURL;

export function registerApi(user: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/user/register`, user).then(res => res.data);
  }
  return API.post('Backend', "/user/register", {body: user});
}
